<script setup>
import { ref, computed, onMounted } from 'vue';
import { useToggle } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';

import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import CampaignLayout from 'dashboard/components-next/Campaigns/CampaignLayout.vue';
import QRBuhoCampaignDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/QRBuhoCampaign/QRBuhoCampaignDialog.vue';
import WhatsAppCampaignEmptyState from 'dashboard/components-next/Campaigns/EmptyState/WhatsAppCampaignEmptyState.vue';
import CampaignList from 'dashboard/components-next/Campaigns/Pages/CampaignPage/CampaignList.vue';
import ConfirmDeleteCampaignDialog from 'dashboard/components-next/Campaigns/Pages/CampaignPage/ConfirmDeleteCampaignDialog.vue';

const { t } = useI18n();
const store = useStore();
const [showQRBuhoCampaignDialog, toggleQRBuhoCampaignDialog] = useToggle();

const selectedCampaign = ref(null);
const confirmDeleteCampaignDialogRef = ref(null);

const uiFlags = useMapGetter('campaigns/getUIFlags');
const isFetchingCampaigns = computed(() => uiFlags.value.isFetching);

const QRBuhoCampaigns = computed(
  () => store.getters['campaigns/getQRBuhoCampaigns']
);

const hasNoQRBuhoCampaigns = computed(
  () => QRBuhoCampaigns.value?.length === 0 && !isFetchingCampaigns.value
);

const handleCreateCampaign = () => {
  toggleQRBuhoCampaignDialog();
};

const handleEdit = () => {
  // TODO: Implementar funcionalidad de edición - sujeta a evaluación
};

const handleDelete = campaign => {
  selectedCampaign.value = campaign;
  confirmDeleteCampaignDialogRef.value.dialogRef.open();
};

onMounted(() => {
  store.dispatch('campaigns/get');
});
</script>

<template>
  <CampaignLayout
    :header-title="t('CAMPAIGN.QRBUHO.HEADER_TITLE')"
    :button-label="t('CAMPAIGN.QRBUHO.NEW_CAMPAIGN')"
    @click="handleCreateCampaign"
    @close="toggleQRBuhoCampaignDialog(false)"
  >
    <template #action>
      <QRBuhoCampaignDialog
        v-if="showQRBuhoCampaignDialog"
        @close="toggleQRBuhoCampaignDialog(false)"
      />
    </template>

    <div
      v-if="isFetchingCampaigns"
      class="flex items-center justify-center py-10 text-n-slate-11"
    >
      <Spinner />
    </div>

    <CampaignList
      v-else-if="!hasNoQRBuhoCampaigns"
      :campaigns="QRBuhoCampaigns"
      @edit="handleEdit"
      @delete="handleDelete"
    />

    <WhatsAppCampaignEmptyState
      v-else
      :title="t('CAMPAIGN.QRBUHO.EMPTY_STATE.TITLE')"
      :subtitle="t('CAMPAIGN.QRBUHO.EMPTY_STATE.SUBTITLE')"
      class="pt-14"
    />

    <ConfirmDeleteCampaignDialog
      ref="confirmDeleteCampaignDialogRef"
      :selected-campaign="selectedCampaign"
    />
  </CampaignLayout>
</template>
